import React from 'react';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './BusinessObjects/Redux/app/store';
import { BrowserRouter } from 'react-router-dom';
import { BASENAME } from './Utils/RoutePath';
import {createRoot} from 'react-dom/client';
import {
    QueryClient,
    QueryClientProvider,
} from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

// Create a client
const queryClient = new QueryClient()

const root = createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter basename={BASENAME}>
                <App />
                <ReactQueryDevtools initialIsOpen={false} />
            </BrowserRouter>
        </QueryClientProvider>
    </Provider>
);
